import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IFormModelMessage } from '@app/shared/model/form-error-message.model';

@Component({
  selector: 'app-input-errors',
  templateUrl: './input-errors.component.html',
  styleUrls: ['./input-errors.component.scss'],
})
export class InputErrorsComponent implements OnInit {
  @Input() control: FormControl;
  @Input() additionalFormErrorMsgs: IFormModelMessage[] = [];

  constructor() {}

  ngOnInit(): void {}
}
